export default __webpack_public_path__ + "static/media/gun.e9db9e98.mp3";